import styled from 'styled-components';
export const DialogTitleWrapper = styled.div`
  flex: 0 0 auto;
  margin: 0;
  padding: 16px 24px;
`;